// @context TGW-2694 チケットの説明（events_plans.description）にイベント本文がまるごと貼られ、
//   1文字ごとの自動保存が ValueTooLong で500になり続けた（本番で1秒に8件の通知）。
import {
  PLAN_DESCRIPTION_MAX_LENGTH,
  isPlanDescriptionAtLimit,
  isPlanDescriptionTooLong,
} from './plan_description';

describe('PLAN_DESCRIPTION_MAX_LENGTH', () => {
  // schema.rb は limit 無しの t.string だが、config/initializers/mysqlpls.rb で既定が 191 になっている。
  // 255 にすると 192〜255 文字が DB に弾かれて500のまま残る（c_dev2 で再現済み）。
  it('DB の列（varchar(191)）と同じ 191 文字', () => {
    expect(PLAN_DESCRIPTION_MAX_LENGTH).toBe(191);
  });
});

describe('isPlanDescriptionAtLimit（赤文字で知らせるか）', () => {
  it('190 文字では知らせない', () => {
    expect(isPlanDescriptionAtLimit('あ'.repeat(190))).toBe(false);
  });

  it('191 文字（これ以上入力できない）で知らせる', () => {
    expect(isPlanDescriptionAtLimit('あ'.repeat(191))).toBe(true);
  });

  it('192 文字以上（日本語入力の確定前などですり抜けた場合）でも知らせる', () => {
    expect(isPlanDescriptionAtLimit('あ'.repeat(192))).toBe(true);
  });

  it('空・未設定では知らせない', () => {
    expect(isPlanDescriptionAtLimit('')).toBe(false);
    expect(isPlanDescriptionAtLimit(null)).toBe(false);
    expect(isPlanDescriptionAtLimit(undefined)).toBe(false);
  });
});

describe('isPlanDescriptionTooLong（自動保存を送らないか）', () => {
  it('191 文字までは送る', () => {
    expect(isPlanDescriptionTooLong('あ'.repeat(191))).toBe(false);
  });

  it('192 文字以上は送らない（送ると DB に弾かれて500になる）', () => {
    expect(isPlanDescriptionTooLong('あ'.repeat(192))).toBe(true);
    expect(isPlanDescriptionTooLong('あ'.repeat(255))).toBe(true);
  });

  it('空・未設定は送る', () => {
    expect(isPlanDescriptionTooLong('')).toBe(false);
    expect(isPlanDescriptionTooLong(null)).toBe(false);
    expect(isPlanDescriptionTooLong(undefined)).toBe(false);
  });
});
